export const MODULE_NAME = 'PROPERTY_MANAGERS_MODULE';
